// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610012305/js/" + chunkId + "." + {"44":"3d95bd54","225":"7788f9a2","481":"00923806","486":"95300acf","770":"db11b965"}[chunkId] + ".0.08051022645658745.chunk.js";
};